import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=ea2f079a&scoped=true&"
import script from "./orders.vue?vue&type=script&lang=js&"
export * from "./orders.vue?vue&type=script&lang=js&"
import style0 from "./orders.vue?vue&type=style&index=0&id=ea2f079a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2f079a",
  null
  
)

export default component.exports